import React from 'react'
import DesignerAnnotationHeader from './DesignerAnnotationHeader'
import DesignerIssueType from './DesignerIssueType'
import DesignerAnnotationCommentBox from './DesignerAnnotationCommentBox'
import DesignerPageNumber from './DesignerPageNumber'
import DesignerActions from './DesignerActions'

class DesignerAnnotation extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      comment: this.props.message || '',
      pubIssueId: this.props.annotation.pub_issue_type_id || 1,
      page: this.props.annotation.page || 1,
      annoType: this.setAnnoType() || 'Comment'
    }
    this.emojis = this.props.emojis
    this.deletable = this.props.paths.update !== null
    this.saveOnPhotoNavigation = false

    this.handlePageChange = this.handlePageChange.bind(this)
    this.onIssueChange = this.onIssueChange.bind(this)
    this.handleTypeChange = this.handleTypeChange.bind(this)
    this.addPhotos = this.addPhotos.bind(this)
    this.save = this.save.bind(this)
    this.delete = this.delete.bind(this)
    this.handleMessageChange = this.handleMessageChange.bind(this)
    this.transactionLock = false
    this.name = "DesignerAnnotation"
  }

  setAnnoType() {
    return Object.keys(this.dbAnnotationTypes()).find(key =>
      this.dbAnnotationTypes()[key] === this.props.annotation.type
    )
  }

  dbAnnotationTypes(){
    return {
      "Comment" : "Annotation::PubIssue",
      "CSR Note" : "Annotation::CsrNote"
    }
  }

  addPhotos(event){
    this.saveOnPhotoNavigation = true
    this.save(event)
  }

  onIssueChange(selected){
    const selectedIssue = $.grep(this.props.issues, (arr) => {
      return arr[1] == selected;
    })[0];
    this.setState({
      pubIssueId: selected,
      comment: selectedIssue[2]
    })
  }

  handleTypeChange(type){
    this.setState({annoType: type})
  }

  save(event){
    event.preventDefault()
    if (this.transactionLock) { return false }

    this.transactionLock = true
    let opts = {}

    if (this.props.annotation.id) {
      opts["path"] = this.props.paths.update;
      opts["method"] = 'patch';
      opts["update_first_message"] = true;
    } else {
      opts["path"] = this.props.paths.save;
      opts["method"] = 'post';
    }

    this.syncToServer(opts)
  }

  delete(){
    this.syncToServer({
      path: this.props.paths.update,
      method: 'delete'
    });
  }

  handleMessageChange(text){
    this.setState({comment: text});
  }

  handlePageChange(val){
    this.setState({page: val});
  }

  showNotice(){
    if (this.state.annoType == "CSR Note") {
      return "CSR Notes are not visible to the Sales User."
    } else {
      return ""
    }
  }

  addFormAnnotationAttrs(form){
    form.setRootParam('annotation')
    form.addInput('annotatable_type', 'PublicationJob');
    form.addInput('annotatable_id', this.props.job.id);
    form.addInput('type', this.dbAnnotationTypes()[this.state.annoType]);
    form.addInput('pub_issue_type_id', this.state.pubIssueId);
    form.addInput('messages_attributes[0][content]', this.state.comment);
    form.addInput('page', this.state.page);
  }

  syncToServer(opts){
    let form = new N2Styles.manualForm(opts.path)
    form.form.attr('method', opts.method);
    this.addFormAnnotationAttrs(form);
    if (opts.update_first_message) {
      form.addInput('first_message', true);
    }
    form.sync({
      success: this.submitSuccess,
      error: this.submitError,
      context: this
    });
  }

  submitError(req) {
    this.transactionLock = false
    new N2Styles.toast(req.responseJSON.errors)
  }

  submitSuccess(resp){
    if (this.saveOnPhotoNavigation) {
      N2.navigate(`${this.props.paths.index}/${resp.id}/edit`, { action: "replace" })
      N2.navigate(`/annotations/${resp.id}/assets`)
    } else {
      N2.navigate(this.props.paths.index)
    }
  }

  render() {
    return (
      <div className="card">
        <DesignerAnnotationHeader 
          triDot={this.props.csr_available}
          handleTypeChange={this.handleTypeChange}
          annotation={this.props.annotation}
        />
        <form onSubmit={this.save}>
          <DesignerIssueType
            onIssueChange={this.onIssueChange}
            issues={this.props.issues}
            notice={this.showNotice()}
            pubIssueId={this.state.pubIssueId}
          />
          <DesignerAnnotationCommentBox
            klass={this}
            comment={this.state.comment}
            handleMessageChange={this.handleMessageChange}
          />
          <div className="card-block separator p-0">
            <DesignerPageNumber
              handlePageChange={this.handlePageChange}
              addPhotos={this.addPhotos}
              page={this.state.page}
            />
            <DesignerActions
              cancelPath={this.props.paths.index}
              deletable={this.deletable}
              handleDelete={this.delete}
            />
          </div>
        </form>
      </div>
    )
  }
}

export default DesignerAnnotation
